import type {PropsWithChildren} from 'react';

import {ArrowRightIcon} from '@/modules/foundation/components/icons/arrow-right-icon';
import {Link} from '@/modules/foundation/components/link';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = PropsWithChildren & {
	href: string;
	className?: string;
	iconClassName?: string;
	targetBlank?: boolean;
};

export const ArrowLink = ({href, children, className, iconClassName, targetBlank}: Props) => {
	return (
		<Link
			href={href}
			targetBlank={targetBlank}
			className={cn(
				[
					'font-semibold',
					'text-lg',
					'gap-4',
					'flex',
					'justify-between',
					'items-center',
					'no-underline',
					'hover:text-primary-15',
					'group/arrowlink',
					'transition-colors',
				],
				className,
			)}
		>
			{children}
			<ArrowRightIcon
				aria-hidden
				className={cn(
					[
						'text-grey-25',
						'group-hover/arrowlink:text-primary-15',
						'text-base',
						'shrink-0',
						'mr-2',
						'group-hover/arrowlink:mr-0',
						'transition-all',
					],
					iconClassName,
				)}
			/>
		</Link>
	);
};
